<template>
  <div class="underLogoPhrase">
    <h2 class="font-weight-bold mb-4 centers">Les Animaux</h2>
    <p class="littlesize">
      Dernières mises à jour :
      <br>
      <span v-if="lastUpdateChien">chien : {{ new Date(lastUpdateChien).toLocaleString() }}</span>
      <span v-if="lastUpdateChat"><br> chat : {{ new Date(lastUpdateChat).toLocaleString() }}</span>
    </p>
  </div>

  <!-- Filtres -->
  <div class="container mb-4">
    <div class="row">
      <!-- FILTRE ESPECE -->
      <div class="col-md-2 mb-2">
        <select v-model="filtres.type" class="form-control" @change="appliquerFiltre">
          <option value="">Espèce</option>
          <option value="chien">Chien</option>
          <option value="chat">Chat</option>
          <option value="nac">NAC</option>
        </select>
      </div>

      <!-- FILTRE SEXE -->
      <div class="col-md-2 mb-2">
        <select v-model="filtres.sexe" class="form-control" @change="appliquerFiltre">
          <option value="">Sexe</option>
          <option value="male">Mâle</option>
          <option value="female">Femelle</option>
        </select>
      </div>

      <!-- FILTRE AGE -->
      <div class="col-md-2 mb-2">
        <select v-model="filtres.age" class="form-control" @change="appliquerFiltre">
          <option value="">Âge</option>
          <option value="bebe">Bébé (- 6 mois)</option>
          <option value="ado">Ado (6m - 2 ans)</option>
          <option value="adulte">Adulte (+ 2 ans)</option>
        </select>
      </div>

      <!-- BOUTON RESET -->
      <div class="col-md-2 mb-2">
        <button class="btn btn-secondary w-100" @click="resetFiltres">Réinitialiser</button>
      </div>
    </div>
  </div>

  <!-- Liste animaux -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-3" v-for="animau in animauxFiltres" :key="animau.id">
        <router-link
          :to="'/animaux/' + animau.id"
          class="card"
          style="height: auto; min-height: 350px;"
        >
          <div>
            <img
              :src="'https://admin.asso-refuge.fr/images/' + animau.img1"
              :alt="'photo du ' + animau.type + ' ' + animau.name"
              class="tailleimg"
              :title="animau.name + ' ' + animau.race"
            />
          </div>
          <div class="endessous" style="margin-top: 10px !important;margin-bottom: 30px;">
            <h4 class="namedogtitleback">{{ animau.name }}</h4>
            <h6>{{ animau.race }}</h6>
            <h6><strong>Age: {{ calculateAge(animau.naissance) }}</strong></h6>
            <h6 style="color:red">{{ animau.huge_information }}</h6>
            <i class="fas fa-plus-circle"></i>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import convertAge from '../components/getAge.js';

export default {
  data() {
    return {
      animaux: [],
      animauxFiltres: [],
      lastUpdateChien: null,
      lastUpdateChat: null,
      filtres: {
        type: '',
        sexe: '',
        couleur: '',
        age: '',
        ville: ''
      }
    };
  },
  computed: {
    couleursDisponibles() {
      const couleurs = this.animaux.map(a => a.couleur).filter(c => c);
      return [...new Set(couleurs)];
    },
    villesDisponibles() {
      const villes = this.animaux.map(a => a.ville).filter(v => v);
      return [...new Set(villes)];
    }
  },
  mounted() {
    const idSite = this.$idSite;
    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(response => response.json())
      .then(data => {
        this.animaux = data;
        this.appliquerFiltre();
        this.calculerDernieresMAJ();
      })
      .catch(error => {
        console.error('Erreur :', error.message);
      });
  },
  methods: {
    appliquerFiltre() {
      const { type, sexe, couleur, age, ville } = this.filtres;

      this.animauxFiltres = this.animaux
        .filter(animal => {
          let match = true;

          if (type && animal.type !== type) match = false;
          if (sexe && animal.sexe !== sexe) match = false;
          if (couleur && animal.couleur !== couleur) match = false;
          if (ville && animal.ville !== ville) match = false;

          if (age) {
            const mois = this.ageEnMois(animal.naissance);
            if (age === 'bebe' && mois >= 6) match = false;
            if (age === 'ado' && (mois < 6 || mois > 24)) match = false;
            if (age === 'adulte' && mois <= 24) match = false;
          }

          return match;
        })
        // 🔽 Trie du plus âgé (naissance la plus ancienne) au plus jeune
        .sort((a, b) => new Date(a.naissance) - new Date(b.naissance));
    },
    resetFiltres() {
      this.filtres = { type: '', sexe: '', couleur: '', age: '', ville: '' };
      this.appliquerFiltre();
    },
    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth);
    },
    ageEnMois(dateOfBirth) {
      if (!dateOfBirth) return 0;
      const birth = new Date(dateOfBirth);
      const now = new Date();
      return (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
    },
    calculerDernieresMAJ() {
      const chiens = this.animaux.filter(a => a.type === 'chien');
      const chats = this.animaux.filter(a => a.type === 'chat');

      const maxDate = array =>
        array.reduce((latest, current) =>
          new Date(current.created_at) > new Date(latest.created_at) ? current : latest,
        array[0]);

      this.lastUpdateChien = chiens.length ? maxDate(chiens).created_at : null;
      this.lastUpdateChat = chats.length ? maxDate(chats).created_at : null;
    }
  }
};
</script>
